import anime from 'animejs'
import { addIntersectionItem } from '../util'

const VenCirclesObj = {
    el: null,
    top: null,
    startPosition: null,
    distance: null,
    animation: null,
    circle1Pos: null,
    circle3Pos: null,
    clipTopPos: null,
    clipBotPos: null
}

const startOffsetRatio = 0.6
const distanceOffsetRatio = 0.5

let animationFrame

export function VenCircles() {
    const elements = document.querySelectorAll('.js-ven-circles')
    return Array.from(elements).map(create)
}

function create(el) {
    var Obj = Object.create(VenCirclesObj)
    init.call(Obj, el)
    return Obj
}

function init(el) {
    if (!el) {
        return
    }

    this.el = el
    addIntersectionItem(this.el, getTopPosition.bind(this))

    this.circle1Pos = '50%'
    this.circle3Pos = '-50%'
    this.clipTopPos = '50%'
    this.clipBotPos = '50%'

    this.animation = anime({
        targets: this,
        circle1Pos: '12.5%',
        circle3Pos: '-12.5%',
        clipTopPos: '13%',
        clipBotPos: '87.5%',
        easing: 'linear',
        autoplay: false,
        duration: 2000,
        update: update.bind(this)
    })

    window.addEventListener('scroll', scroll.bind(this))
    window.addEventListener('resize', setPositions.bind(this))
}

function scroll() {
    if (animationFrame) {
        return
    }

    if (!this.top) {
        return
    }

    animationFrame = requestAnimationFrame(() => {
        let diff = window.scrollY - this.startPosition
        let percent = diff / this.distance
        percent = Math.max(Math.min(1, percent), 0)
        this.animation.seek(this.animation.duration * percent)

        animationFrame = null
    })
}

function update() {
    this.el.style.setProperty('--circle-1-position', this.circle1Pos)
    this.el.style.setProperty('--circle-3-position', this.circle3Pos)
    this.el.style.setProperty('--clip-top-position', this.clipTopPos)
    this.el.style.setProperty('--clip-bot-position', this.clipBotPos)
}

function getTopPosition(_, entry) {
    if (!entry.isIntersecting || this.top) {
        return
    }

    const { top } = this.el.getBoundingClientRect()
    this.top = top + window.scrollY
    setPositions.call(this)
}

function setPositions() {
    if (!this.top) {
        return
    }

    const { top } = this.el.getBoundingClientRect()
    this.top = top + window.scrollY
    this.startPosition = this.top - window.innerHeight * startOffsetRatio
    this.distance = window.innerHeight * distanceOffsetRatio
    scroll.call(this)
}
